import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  emptyProductContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(6),
    borderRadius: theme.spacing(1),
  },
  emptyProductInnerContainer: {
    height: theme.spacing(40),
    display: 'flex',
    flexDirection: 'row',
  },
  leftContainer: {
    display: 'flex',
  },
  thumbnailImages: {
    width: theme.spacing(34),
    height: theme.spacing(40),
    borderRadius: theme.spacing(1),
  },
  rightContainer: {
    width: theme.spacing(69.25),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: theme.spacing(6),
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
    letterSpacing: '0.25px',
  },
  subHeadingContainer: {
    marginTop: theme.spacing(3),
  },
  subHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  dropDownContainer: {
    marginTop: theme.spacing(5),
    display: 'flex',
    flexDirection: 'row',
  },
  cloudChangeContainer: {
    marginRight: theme.spacing(2),
  },
  toolTipView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  submitButton: {
    maxWidth: theme.spacing(30),
  },
}))
